// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ILetterOfMedicalNecessityClaimDto } from './ILetterOfMedicalNecessityClaimDto';
import {
    ILetterOfMedicalNecessityClaimDtoFromJSON,
    ILetterOfMedicalNecessityClaimDtoFromJSONTyped,
    ILetterOfMedicalNecessityClaimDtoToJSON,
    ILetterOfMedicalNecessityClaimDtoToJSONTyped,
} from './ILetterOfMedicalNecessityClaimDto';

/**
 * 
 * @export
 * @interface ILetterOfMedicalNecessityResponse
 */
export interface ILetterOfMedicalNecessityResponse {
    /**
     * 
     * @type {number}
     * @memberof ILetterOfMedicalNecessityResponse
     */
    id?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ILetterOfMedicalNecessityResponse
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ILetterOfMedicalNecessityResponse
     */
    description?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof ILetterOfMedicalNecessityResponse
     */
    valid_from?: Date;
    /**
     * 
     * @type {Date}
     * @memberof ILetterOfMedicalNecessityResponse
     */
    valid_to?: Date;
    /**
     * 
     * @type {number}
     * @memberof ILetterOfMedicalNecessityResponse
     */
    document_id?: number;
    /**
     * 
     * @type {number}
     * @memberof ILetterOfMedicalNecessityResponse
     */
    employee_id?: number;
    /**
     * 
     * @type {number}
     * @memberof ILetterOfMedicalNecessityResponse
     */
    organization_id?: number;
    /**
     * 
     * @type {string}
     * @memberof ILetterOfMedicalNecessityResponse
     */
    organization_path?: string;
    /**
     * 
     * @type {Array<ILetterOfMedicalNecessityClaimDto>}
     * @memberof ILetterOfMedicalNecessityResponse
     */
    claims?: Array<ILetterOfMedicalNecessityClaimDto> | null;
    /**
     * 
     * @type {Date}
     * @memberof ILetterOfMedicalNecessityResponse
     */
    created_at?: Date;
    /**
     * 
     * @type {string}
     * @memberof ILetterOfMedicalNecessityResponse
     */
    file_url?: string;
    /**
     * 
     * @type {string}
     * @memberof ILetterOfMedicalNecessityResponse
     */
    thumbnail_url?: string;
}

/**
 * Check if a given object implements the ILetterOfMedicalNecessityResponse interface.
 */
export function instanceOfILetterOfMedicalNecessityResponse(value: object): value is ILetterOfMedicalNecessityResponse {
    return true;
}

export function ILetterOfMedicalNecessityResponseFromJSON(json: any): ILetterOfMedicalNecessityResponse {
    return ILetterOfMedicalNecessityResponseFromJSONTyped(json, false);
}

export function ILetterOfMedicalNecessityResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ILetterOfMedicalNecessityResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'valid_from': json['valid_from'] == null ? undefined : (new Date(json['valid_from'])),
        'valid_to': json['valid_to'] == null ? undefined : (new Date(json['valid_to'])),
        'document_id': json['document_id'] == null ? undefined : json['document_id'],
        'employee_id': json['employee_id'] == null ? undefined : json['employee_id'],
        'organization_id': json['organization_id'] == null ? undefined : json['organization_id'],
        'organization_path': json['organization_path'] == null ? undefined : json['organization_path'],
        'claims': json['claims'] == null ? undefined : ((json['claims'] as Array<any>).map(ILetterOfMedicalNecessityClaimDtoFromJSON)),
        'created_at': json['created_at'] == null ? undefined : (new Date(json['created_at'])),
        'file_url': json['file_url'] == null ? undefined : json['file_url'],
        'thumbnail_url': json['thumbnail_url'] == null ? undefined : json['thumbnail_url'],
    };
}

export function ILetterOfMedicalNecessityResponseToJSON(json: any): ILetterOfMedicalNecessityResponse {
    return ILetterOfMedicalNecessityResponseToJSONTyped(json, false);
}

export function ILetterOfMedicalNecessityResponseToJSONTyped(value?: ILetterOfMedicalNecessityResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'description': value['description'],
        'valid_from': value['valid_from'] == null ? undefined : ((value['valid_from']).toISOString()),
        'valid_to': value['valid_to'] == null ? undefined : ((value['valid_to']).toISOString()),
        'document_id': value['document_id'],
        'employee_id': value['employee_id'],
        'organization_id': value['organization_id'],
        'organization_path': value['organization_path'],
        'claims': value['claims'] == null ? undefined : ((value['claims'] as Array<any>).map(ILetterOfMedicalNecessityClaimDtoToJSON)),
        'created_at': value['created_at'] == null ? undefined : ((value['created_at']).toISOString()),
        'file_url': value['file_url'],
        'thumbnail_url': value['thumbnail_url'],
    };
}

